import { render, staticRenderFns } from "./RadioDefault.vue?vue&type=template&id=0838e30c"
import script from "./RadioDefault.vue?vue&type=script&lang=js"
export * from "./RadioDefault.vue?vue&type=script&lang=js"
import style0 from "./RadioDefault.vue?vue&type=style&index=0&id=0838e30c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports